<template>
    <DModal
        v-model="activity_log_comment"
        :show="showModal"
        :title="__('customers.contracts.delete_confirm_title')"
        :message="message"
        is-confirm
        is-error
        :is-awaiting-validation="true"
        :show-change-reason-input="true"
        @update:show="$emit('update:showModal', $event)"
        @confirm="deleteContractConfirm"
        @close="$emit('close-modal')"
    />
</template>

<script>
export default {
    name: 'DeleteContractModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        redirectTo: {
            type: String,
            default: 'contract-list'
        },
        message: {
            type: String,
            default: ''
        },
        filters: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            activity_log_comment: ''
        }
    },
    methods: {
        deleteContractConfirm () {
            this.$inertia.post(this.$route('customers.customers.contracts.delete-contract', {
                customer: this.contract.customer_id,
                contract: this.contract.id,
                redirectTo: this.redirectTo,
                activity_log_comment: this.activity_log_comment,
                filters: this.filters
            }),
            {},
            {
                onSuccess: () => {
                    this.$emit('close-modal')
                }
            })
        }
    }
}
</script>
